// src/pages/dashboard/components/LatestTransactions/index.js
// (Importaciones y estilos como estaban)
import React, { useState, useContext } from 'react'; // Importar useContext
import {
  Box,
  Card,
  Typography,
  Tabs,
  Tab,
  Button
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import AuthContext from '../../../../context/AuthContext'; // Asegúrate que la ruta sea correcta

const LatestTransactions = ({ invoices, clients }) => {
  // Usar el contexto de autenticación para acceder a hasRole
  const { hasRole } = useContext(AuthContext);

  // CTA compacto y sobrio para las acciones rápidas del dashboard.
  const actionButtonStyle = {
    borderRadius: '7px',
    color: '#1C1525',
    fontWeight: 700,
    minHeight: '34px',
    padding: '6px 12px',
    textTransform: 'none',
    backgroundColor: '#F5A623',
    boxShadow: 'none',
    transition: 'background-color 0.16s ease, box-shadow 0.16s ease',
    border: '1px solid rgba(255, 255, 255, 0.06)',
    fontSize: '12.5px',
    lineHeight: 1,
    '& .MuiButton-startIcon': {
      marginRight: '5px',
      '& svg': { fontSize: '17px' },
    },
    '&:hover': {
      backgroundColor: '#E99A18',
      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
    },
    '&:active': {
      backgroundColor: '#D9890D',
      boxShadow: 'none',
    },
    '&.Mui-disabled': {
      backgroundColor: '#6F6A72',
      color: 'rgba(255, 255, 255, 0.6)',
    }
  };

  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Card
      sx={{
        borderRadius: 2,
        bgcolor: '#131316',
        border: '1px solid #333',
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          sx={{
            '& .MuiTab-root': { color: '#888' },
            '& .Mui-selected': { color: 'white' },
            '& .MuiTabs-indicator': { backgroundColor: '#4477CE' }
          }}
        >
          <Tab label="FACTURAS RECIENTES" />
          <Tab label="CLIENTES RECIENTES" />
        </Tabs>
      </Box>

      {/* Contenido de Facturas Recientes */}
      {tabValue === 0 && (
        <Box sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6" color="white">Facturas Recientes</Typography>
            {/* === MODIFICACIÓN AQUÍ === */}
            {/* Mostrar botón solo si el usuario NO es 'visor' */}
            {!hasRole('visor') && (
              <Button
                onClick={() => window.location.href = '/invoices?action=new'}
                startIcon={<AddIcon />}
                variant="contained"
                sx={{
                  ...actionButtonStyle
                }}
              >
                Nueva factura
              </Button>
            )}
            {/* === FIN MODIFICACIÓN === */}
          </Box>

          {/* (Resto de la tabla de facturas como estaba) */}
          <Box sx={{ overflowX: 'auto' }}>
            <Box sx={{ minWidth: 700, width: '100%' }}>
              <Box sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 2fr 1fr 1fr 1fr 1fr',
                bgcolor: '#1B1B1F',
                borderRadius: 1,
                p: 2,
                fontWeight: 'bold'
              }}>
                <Typography variant="subtitle2" color="#CCC">Nº Factura</Typography>
                <Typography variant="subtitle2" color="#CCC">Cliente</Typography>
                <Typography variant="subtitle2" color="#CCC">Fecha</Typography>
                <Typography variant="subtitle2" color="#CCC">Total</Typography>
                <Typography variant="subtitle2" color="#CCC">Moneda</Typography>
                <Typography variant="subtitle2" color="#CCC">Estado</Typography>
              </Box>

              {invoices?.length > 0 ? (
                invoices.map((factura) => (
                  <Box key={factura.id} sx={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 2fr 1fr 1fr 1fr 1fr',
                    p: 2,
                    borderBottom: '1px solid #333'
                  }}>
                    <Typography variant="body2" color="white">{factura.id}</Typography>
                    <Typography variant="body2" color="white">{factura.cliente}</Typography>
                    <Typography variant="body2" color="white">{factura.fecha}</Typography>
                    <Typography variant="body2" color="white">{factura.total.toLocaleString()}</Typography>
                    <Typography variant="body2" color="white">{factura.moneda}</Typography>
                    <Typography
                      variant="body2"
                      color="white"
                      sx={{ textWrap: 'nowrap' }}
                    >
                      {factura.estado}
                    </Typography>
                  </Box>
                ))
              ) : (
                <Box sx={{ p: 3, textAlign: 'center' }}>
                  <Typography color="white">No hay facturas disponibles</Typography>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      )}

      {/* Contenido de Clientes Recientes */}
      {tabValue === 1 && (
        <Box sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6" color="white">Clientes Recientes</Typography>
            {/* === MODIFICACIÓN AQUÍ === */}
            {/* Mostrar botón solo si el usuario NO es 'visor' */}
            {!hasRole('visor') && (
              <Button
                onClick={() => window.location.href = '/clients?action=new'}
                startIcon={<AddIcon />}
                variant="contained"
                sx={{
                  ...actionButtonStyle
                }}
              >
                Nuevo cliente
              </Button>
            )}
            {/* === FIN MODIFICACIÓN === */}
          </Box>

          {/* (Resto de la tabla de clientes como estaba) */}
           <Box sx={{ overflowX: 'auto' }}>
            <Box sx={{ minWidth: 800, width: '100%' }}>
              <Box sx={{
                display: 'grid',
                gridTemplateColumns: '2fr 2fr 2fr 1fr',
                bgcolor: '#1B1B1F',
                borderRadius: 1,
                p: 2,
                fontWeight: 'bold'
              }}>
                <Typography variant="subtitle2" color="#CCC">Nombre</Typography>
                <Typography variant="subtitle2" color="#CCC">Correo</Typography>
                <Typography variant="subtitle2" color="#CCC">Documento</Typography>
                <Typography variant="subtitle2" color="#CCC" align="right">Facturas</Typography>
              </Box>

              {clients?.length > 0 ? (
                clients.map((cliente) => (
                  <Box key={cliente.id} sx={{
                    display: 'grid',
                    gridTemplateColumns: '2fr 2fr 2fr 1fr',
                    p: 2,
                    borderBottom: '1px solid #333'
                  }}>
                    <Typography variant="body2" color="white">{cliente.nombre}</Typography>
                    <Typography
                      variant="body2"
                      color="white"
                      sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {cliente.email ? `📧 ${cliente.email}` : ''}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="white"
                      sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {cliente.documento ? `📝 ${cliente.documento}` : ''}
                    </Typography>
                    <Typography variant="body2" color="white" align="right">{cliente.facturas}</Typography>
                  </Box>
                ))
              ) : (
                <Box sx={{ p: 3, textAlign: 'center' }}>
                  <Typography color="white">No hay clientes disponibles</Typography>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      )}
    </Card>
  );
};

export default LatestTransactions;
